<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
      isActive: {
        type: Boolean,
        default: false,
      },

      isHoveredOn: {
        type: Boolean,
        default: false,
      },
      width: {
        default: 22,
        type: Number,
      },
      height: {
        default: 22,
        type: Number,
      },
    },

    computed: {

    },
  };
</script>

<template>
  <svg
    :height="width"
    :width="height"
    fill="none"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_37115_265903"
      height="18"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
      width="20"
      x="1"
      y="2"
    >
      <path
        clip-rule="evenodd"
        d="M3.79869 11.0017C3.79869 6.37257 7.62119 2.6234 12.287 2.75173C16.5862
2.8709 20.1795 6.46423 20.2987 10.7634C20.427 15.4292 16.6779 19.2517 12.0487 19.2517C10.1329 19.2517 8.38203 18.6009
6.98869 17.5009C6.55786 17.1709 6.53036 16.5201 6.91536 16.1351C7.24536 15.8051 7.75869 15.7776 8.12536 16.0617C9.20703
16.9142 10.5729 17.4184 12.0487 17.4184C15.6237 17.4184 18.5112 14.4942 18.4654 10.9101C18.4195 7.50007 15.5504 4.6309
12.1404 4.58507C8.54703 4.53923 5.63203 7.42673 5.63203 11.0017H7.27286C7.68536 11.0017 7.88703 11.4967 7.60286
11.7809L5.04536 14.3476C4.86203 14.5309 4.57786 14.5309 4.39453 14.3476L1.83703 11.7809C1.54369 11.4967 1.74536 11.0017
2.15786 11.0017H3.79869ZM11.132 8.02257C11.132 7.64673 11.4437 7.33507 11.8195 7.33507C12.1954 7.33507 12.507 7.64673
12.507 8.0134V11.1301L15.147 12.6976C15.4679 12.8901 15.5779 13.3117 15.3854 13.6417C15.1929 13.9626 14.7712 14.0726
14.4412 13.8801L11.5812 12.1842C11.3062 12.0192 11.132 11.7167 11.132 11.3959V8.02257Z"
        fill="black"
        fill-rule="evenodd"
      />
    </mask>
    <g mask="url(#mask0_37115_265903)">
      <rect
        :fill="isActive || isHoveredOn ? 'var(--primary-500)' : color"
        height="22"
        width="22"
      />
    </g>
  </svg>
</template>
